"use client";

import { trackClarityEvent } from "@/lib/clarity-event";
import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";
import { useState } from "react";

// Exporting for reuse in other pages
export default function FAQItem({ question, answer }: { question: string, answer: string }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border-b border-zinc-200/80 transition-all bg-transparent">
            <button
                onClick={() => {
                    setIsOpen(!isOpen);
                    if (!isOpen) {
                        trackClarityEvent('faq_expand');
                    }
                }}
                className="w-full flex items-center justify-between py-5 text-left group"
            >
                <span className="text-base font-semibold text-zinc-900 group-hover:text-black transition-colors pr-8">{question}</span>
                <div className="shrink-0 text-zinc-400 group-hover:text-zinc-900 transition-colors">
                    {isOpen ? (
                        <Minus className="h-4 w-4 stroke-[2.5]" />
                    ) : (
                        <Plus className="h-4 w-4 stroke-[2.5]" />
                    )}
                </div>
            </button>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                        className="overflow-hidden"
                    >
                        <div className="pb-5 text-sm text-zinc-600 leading-relaxed pr-8">
                            {answer}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
